<template>

    <div class="app-template sellprint d-noneX printpage">
        <div id="right-panel" class="right-panel">
            <div class="content">
                <div class="">
                    <div class="row">
                        <div class="col-lg-12">
                            <form action="/" method="post" id="form" class="userForm ajaxForm">
                                <div :class="'bgWhite '+printerPaddingLeftClass+' '+printerPaddingRightClass+' '+printerFontSizeClass+' '+printerPaddingTopClass">
                                    <!--<div class="card-header text-center">-->
                                    <!--<strong data-contenthtml="title">Kleopátra virága</strong>-->
                                    <!--</div>-->
                                    <div class="row">
                                        <div class="col-12 scrollHeightEnable600X">

                                            <div v-if="type==='actualPeriodPrint'">

                                                <div v-if="justDate" class="closesDataContainer">{{$t('closes.closesActualDay')}} {{dtT}} </div>
                                                <div v-if="!justDate" class="closesDataContainer">{{$t('closes.closesActualPeriod')}} {{dtStartFormat}} - {{dtStopFormat}}</div>

                                                <span class="closesDataContainer" v-if="(!isNaN(closesSumSum))">
                                                {{$t('closes.closesSumSum')}}<small class="">{{prefix}}</small><span class="">{{closesSumSum}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                                <span class="closesDataContainer" v-if="(!isNaN(closesSumCash))">
                                                {{$t('closes.closesSumCash')}}<small class="">{{prefix}}</small><span class="">{{closesSumCash}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                                <span class="closesDataContainer" v-if="(!isNaN(closesSumCard))">
                                                {{$t('closes.closesSumCard')}}<small class="">{{prefix}}</small><span class="">{{closesSumCard}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                                <span class="closesDataContainer" v-if="(!isNaN(closesSumTransfer))">
                                                {{$t('closes.closesSumTransfer')}}<small class="">{{prefix}}</small><span class="">{{closesSumTransfer}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                                <hr>
                                                <!--<span class="closesDataContainer" v-if="(!isNaN(closesCashRegisterOpens))">-->
                                                <!--{{$t('closes.closesCashRegisterOpens')}}<small class="">{{prefix}}</small><span class="">{{closesCashRegisterOpens}}</span><small class="">{{suffix}}</small>-->
                                            <!--</span><br>-->
                                                <!--<span class="closesDataContainer" v-if="(!isNaN(closesCashRegisterCloses))">-->
                                                <!--{{$t('closes.closesCashRegisterCloses')}}<small class="">{{prefix}}</small><span class="">{{closesCashRegisterCloses}}</span><small class="">{{suffix}}</small>-->
                                            <!--</span><br>-->
                                                <span class="closesDataContainer" v-if="(!isNaN(closesSumCashRegister))">
                                                {{$t('closes.closesSumCashRegister')}}<small class="">{{prefix}}</small><span class="">{{closesSumCashRegister}}</span><small class="">{{suffix}}</small>
                                            </span><br>

                                                <!--name: "Vágott virág", sumprice: "3600.00", sumrealsellprice: "3545.00", sumdiscountprice-->
                                              <div v-if="this.closesItemizedList.length>0&&this.closesButtonItemizedList">
                                                    <table class="w100">
                                                        <tr>
                                                            <td>{{$t('closesprint.name')}}</td>
                                                            <!--<td>{{$t('closesprint.sumprice')}}</td>-->
                                                            <td class="text-right">{{$t('closesprint.sumrealsellprice')}}</td>
                                                            <td class="text-right">{{$t('closesprint.sumdiscountprice')}}</td>
                                                        </tr>
                                                        <tr v-for="(e, index) in this.closesItemizedList">
                                                            <td>{{e.name}} </td>
                                                            <!--<td>{{e.sumprice}}</td>-->
                                                            <td class="text-right"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(e.sumrealsellprice)}} <small class="">{{suffix}}</small></td>
                                                            <td class="text-right"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(e.sumdiscountprice)}} <small class="">{{suffix}}</small></td>
                                                        </tr>
                                                    </table>
                                                </div>

                                            </div>






                                            <div v-if="type==='day'">
                                                <div class="closesDataContainer">{{$t('closesprint.actualDate')}} {{this.dateContainer}}</div>
                                                <span class="closesDataContainer" v-if="(!isNaN(Number(this.SellsByDate)))">
                                                        {{$t('closesprint.SellsByDateContainer')}} <small class="">{{prefix}}</small>{{this.SellsByDate}} <small class="">{{suffix}}</small>
                                                    <br>
                                                    <span class="closesDataContainer" v-if="(!isNaN(this.SellsByDateCash))">
                                                        {{$t('closesprint.SellsByDateContainerCash')}} <small class="">{{prefix}}</small>{{this.SellsByDateCash}} <small class="">{{suffix}}</small>
                                                    </span>
                                                    <span class="closesDataContainer" v-if="(isNaN(this.SellsByDateCash))">
                                                        {{$t('closesprint.SellsByDateContainer2Cash')}}
                                                    </span>
                                                    <br>
                                                    <span class="closesDataContainer" v-if="(!isNaN(this.SellsByDateCard))">
                                                        {{$t('closesprint.SellsByDateContainerCard')}} <small class="">{{prefix}}</small>{{this.SellsByDateCard}} <small class="">{{suffix}}</small>
                                                    </span>
                                                    <span class="closesDataContainer" v-if="(isNaN(this.SellsByDateCard))">
                                                        {{$t('closesprint.SellsByDateContainer2Card')}}
                                                    </span>
                                                    <br>

                                                    <!--name: "Vágott virág", sumprice: "3600.00", sumrealsellprice: "3545.00", sumdiscountprice-->

                                                        <div v-if="this.SellsByDateItemizedList.length>0&&this.closesButtonItemizedList">
                                                            <table class="w100">
                                                                <tr>
                                                                    <td>{{$t('closesprint.name')}}</td>
                                                                    <!--<td>{{$t('closesprint.sumprice')}}</td>-->
                                                                    <td class="text-right">{{$t('closesprint.sumrealsellprice')}}</td>
                                                                    <td class="text-right">{{$t('closesprint.sumdiscountprice')}}</td>
                                                                </tr>
                                                                <tr v-for="(e, index) in this.SellsByDateItemizedList">
                                                                    <td>{{e.name}} </td>
                                                                    <!--<td>{{e.sumprice}}</td>-->
                                                                    <td class="text-right"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(e.sumrealsellprice)}} <small class="">{{suffix}}</small></td>
                                                                    <td class="text-right"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(e.sumdiscountprice)}} <small class="">{{suffix}}</small></td>
                                                                </tr>
                                                            </table>
                                                        </div>

                                                </span>
                                            </div>
                                            <div v-if="type==='month'">
                                                <div class="closesDataContainer">{{$t('closesprint.actualMonth')}} {{this.monthContainer}}</div>
                                                <span class="closesDataContainer" v-if="(!isNaN(Number(this.SellsByMonth)))">
                                                        {{$t('closesprint.SellsByMonthContainer')}} <small class="">{{prefix}}</small>{{this.SellsByMonth}} <small class="">{{suffix}}</small>
                                                    </span>
                                                <span class="closesDataContainer" v-if="(isNaN(this.SellsByMonth))">
                                                        {{$t('closesprint.SellsByMonthContainer2')}}
                                                    </span>
                                            </div>

                                        </div>
                                    </div>
                                    <div id="hidedButtons" class="fFix card-footer d-none  text-center">
                                        <button v-on:click="go_back()" type="button" class="btn btn-success btn-lg btn-finish">
                                            <i class="fa fa-arrow-circle-o-left"></i> {{$t('closesprint.back')}}
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div><!-- .animated -->
            </div><!-- .content -->
        </div>
    </div>

</template>


<script>
    import Helper from '@/helper/Helper';
//    const {ipcRenderer} = require('electron');

    export default {
        name: 'Closesprint',
//        roles: [1, 2, 3, 7, 8, 9],
        data() {
            return {
                prefix: "",
                suffix: "",
                data: {},
                type: "",

                justDate: true,
                dtT: "",
                dtStartFormat: "",
                dtStopFormat: "",
                closesSumSum: "",
                closesSumCash: "",
                closesSumCard: "",
                closesSumTransfer: "",
                closesCashRegisterOpens: "",
                closesCashRegisterCloses: "",
                closesSumCashRegister: "",
                closesItemizedList: [],

                dateContainer: "",
                monthContainer: "",
                SellsByDate: 0,
                SellsByDateCash: 0,
                SellsByDateCard: 0,
                SellsByMonth: 0,
                SellsByDateItemizedList: [],
                closesButtonItemizedList: false,
                printerPaddingLeft: "",
                printerPaddingRight: "",
                printerPaddingTop: "",
                printerPaddingLeftClass: 'printerPaddingLeftdef',
                printerPaddingRightClass: 'printerPaddingRightdef',
                printerPaddingTopClass: 'printerPaddingTopClass',
                printerFontSize: "",
                printerFontSizeClass: 'printerFontSizedef',
                Helper: Helper
            };
        },
        props: {},
        watch: {
            // TODO -- betenni az element-re is.
            printerPaddingLeft: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingLeftClass = 'paddingLeft' + newdata;
                } else {
                    modul.printerPaddingLeftClass = '';
                }
            },
            printerPaddingRight: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingRightClass = 'paddingRight' + newdata;
                } else {
                    modul.printerPaddingRightClass = '';
                }
            },
            printerPaddingTop: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerPaddingTopClass = 'paddingTop' + newdata;
                } else {
                    modul.printerPaddingTopClass = '';
                }
            },
            printerFontSize: function (newdata, olddata) {
                const modul = this;
                if (newdata) {
                    modul.printerFontSizeClass = 'printerFontSize' + newdata;
                } else {
                    modul.printerFontSizeClass = '';
                }
            },
        },

        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
            modul.init(this.$route.params);
            if (localStorage.getItem("printerPaddingLeft")) {
                modul.printerPaddingLeft = localStorage.getItem("printerPaddingLeft");
            }
            if (localStorage.getItem("printerPaddingRight")) {
                modul.printerPaddingRight = localStorage.getItem("printerPaddingRight");
            }
            if (localStorage.getItem("printerPaddingTop")) {
                modul.printerPaddingTop = localStorage.getItem("printerPaddingTop");
            }
            if (localStorage.getItem("printerFontSize")) {
                modul.printerFontSize = localStorage.getItem("printerFontSize");
            }

            if (localStorage.getItem("closesButtonItemizedList")) {
                if (localStorage.getItem("closesButtonItemizedList") === "true" || localStorage.getItem("closesButtonItemizedList") === true) {
                    modul.closesButtonItemizedList = true;
                } else {
                    modul.closesButtonItemizedList = false;
                }
            }

            const printHidingElements = document.querySelectorAll(".printHiding");
            printHidingElements.forEach(function (e, i) {
                e.style.display = "none";
            });
            setTimeout(function () {
                printHidingElements.forEach(function (e, i) {
                    e.removeAttribute('style');
                })
            }, 8000);
            const appVersions = document.getElementsByClassName("appVersion");
            for (let i = 0; i < appVersions.length; i++) {
              appVersions.item(i).classList.add("d-none");
            }
            setTimeout(function () {
                if (document.getElementById("hidedButtons") && document.getElementById("hidedButtons").classList) {
                  document.getElementById("hidedButtons").classList.remove("d-none");
                  const appVersions = document.getElementsByClassName("appVersion");
                  for (let i = 0; i < appVersions.length; i++) {
                    appVersions.item(i).classList.remove("d-none");
                  }
                }
                modul.$router.push({
                  name: "closes", params: {}
                });
              },
                3000
//                100
            );
//            modul.initListener("sellinone");
            modul.printView();
        },
        beforeDestroy() {
            const modul = this;
            modul.offListener();
        },
        methods: {
            go_back(){
                const modul = this;
                modul.$router.push({name: "closes", params: {}})
            },
            init(params){
                const modul = this;
                modul.SellsByDate = params.SellsByDate;
                modul.SellsByDateCash = params.SellsByDateCash;
                modul.SellsByDateCard = params.SellsByDateCard;
                modul.SellsByMonth = params.SellsByMonth;
                modul.SellsByDateItemizedList = (params.SellsByDateItemizedList) ? params.SellsByDateItemizedList : [];
                modul.dateContainer = params.dateContainer;
                modul.monthContainer = params.monthContainer;

                modul.justDate = params.justDate;
                modul.dtT = params.dtT;
                modul.dtStartFormat = params.dtStartFormat;
                modul.dtStopFormat = params.dtStopFormat;
                modul.closesSumSum = params.closesSumSum;
                modul.closesSumCash = params.closesSumCash;
                modul.closesSumCard = params.closesSumCard;
                modul.closesSumTransfer = params.closesSumTransfer;
                modul.closesCashRegisterOpens = params.closesCashRegisterOpens;
                modul.closesCashRegisterCloses = params.closesCashRegisterCloses;
                modul.closesSumCashRegister = params.closesSumCashRegister;
                modul.closesItemizedList = params.closesItemizedList;
                if (params.type === "actualPeriodPrint") {
                    modul.type = "actualPeriodPrint";
                }
                if (params.type === "actualDayPrint") {
                    modul.type = "day";
                    modul.$t('transferreason.expense');
                }
                if (params.type === "previousDayPrint") {
                    modul.type = "day";

                }
                if (params.type === "actualMonthPrint") {
                    modul.type = "month";

                }
                if (params.type === "previousMonthPrint") {
                    modul.type = "month";

                }
            },
            printView: function () {
                setTimeout(function () {
                window.print();
                },0);
//                ipcRenderer.send('printpage', 'ping');
            },
            initListener: function () {
                const modul = this;
//                ipcRenderer.removeAllListeners('printpage-reply');
//                ipcRenderer.on('printpage-reply', (event, arg) => {
//                    console.log(arg);
//                    if (arg === true) {
//                        console.log("true");
//                    }
//                    if (arg === false) {
//                        console.log("false");
//                    }
//                    const message = `Asynchronous message reply: ${arg}`
//                    console.log(message);
////                    if (arg === true) {
//                    console.log("redirect to sellinone")
////                    modul.$router.push({
////                        name: "closes", params: {}
////                    });
////                    }
//                });
            },
            offListener: function (redirectToName) {
//                ipcRenderer.removeAllListeners('printpage-reply');
            },
        },
        components: {},
    };
</script>
<style scoped>
    .printpage {
        color: black;
    }
</style>
